import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {RouteLoopsService} from './route-loops.service';
import {SharedGrid} from '../../shared/grid.model';
import {BaseDashboardComponent} from '../base-dashboard-component';

@Component({
    selector: 'app-route-loops',
    templateUrl: './route-loops.component.html',
    styleUrls: ['./route-loops.component.scss']
})
export class RouteLoopsComponent extends BaseDashboardComponent implements OnChanges {
    @Input() isVisible = false;
    public tableGrid = new SharedGrid();
    public isLoading = false;
    private loaded = false;

    constructor(private serv: RouteLoopsService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isVisible?.currentValue === true && !this.loaded) {
            this._loadData();
        }
    }

    _loadData() {
        this.isLoading = true;
        this.loaded = true;
        this.serv.getRouteLoops().subscribe(
            resp => {
                this.tableGrid.gridData = resp;
                this.tableGrid.gridSort = [];
                this.isLoading = false;
            },
            error => {
                this.isLoading = false;
                console.error('Error occurred loading route loops', error);
            }
        );
    }
}
